import { render, staticRenderFns } from "./ReviseKpoCard.vue?vue&type=template&id=d3922d2e&"
import script from "./ReviseKpoCard.vue?vue&type=script&lang=js&"
export * from "./ReviseKpoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports